import { render } from "./infinite-scroll.vue?vue&type=template&id=2f026a1f&ts=true"
import script from "./infinite-scroll.vue?vue&type=script&lang=ts"
export * from "./infinite-scroll.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__